import { formatCnpj } from "@cafegestor/shared";
import { Link, useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/app/auth";
import { useMe } from "@/app/me";
import { Button, Card, Spinner } from "@/components/ui";
import { setActiveCompanyId } from "@/lib/company-store";

/** Usuário autenticado SEM vínculo: acesso zero aos dados empresariais. */
export function NoAccessPage() {
  const { signOut } = useAuth();
  const { data: me } = useMe();
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="max-w-md">
        <h1 className="text-lg font-semibold">Sem acesso a empresas</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Sua conta ({me?.user.email}) ainda não está vinculada a nenhuma empresa. Peça um convite
          ao responsável e abra o link recebido por e-mail.
        </p>
        <div className="mt-4 flex gap-2">
          {me?.user.isPlatformAdmin && (
            <Link
              to="/plataforma"
              className="inline-flex h-10 items-center rounded-md bg-primary px-4 text-sm text-primary-foreground"
            >
              Ir para a plataforma
            </Link>
          )}
          <Button variant="secondary" onClick={() => void signOut()}>
            Sair
          </Button>
        </div>
      </Card>
    </div>
  );
}

export function SelectCompanyPage() {
  const { data: me, isPending } = useMe();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  if (isPending) return <Spinner />;
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card title="Escolha a empresa" className="w-full max-w-lg">
        <ul className="divide-y">
          {me?.companies.map((c) => (
            <li key={c.id}>
              <button
                className="flex w-full items-center justify-between px-2 py-3 text-left hover:bg-muted"
                onClick={async () => {
                  setActiveCompanyId(c.id);
                  await queryClient.invalidateQueries({ queryKey: ["me"] });
                  await navigate({ to: "/" });
                }}
              >
                <span className="font-medium">{c.name}</span>
                <span className="text-sm text-muted-foreground">{formatCnpj(c.cnpj)}</span>
              </button>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
